import React, { useState } from 'react'
import styles from './SelectDropDown.module.css';
import { FaChevronDown } from 'react-icons/fa';

const SelectDropDown = ({ options, currentOptionKey, onChange, wrapperStyles }) => {
    const [isOpen, setIsOpen] = useState(false);
    const currentOption = options.find(option => option.key === currentOptionKey);

    const handleSelect = (key) => {
        onChange(key);
        setIsOpen(false);
    };

    return (
        <div className={styles.select} style={wrapperStyles}>
            <button
                className={styles.selectButton}
                onClick={() => setIsOpen(!isOpen)}
            >
                {currentOption ? currentOption.label : 'Select an option'}
                <FaChevronDown className={styles.dropdownIcon} />
            </button>
            {isOpen && (
                <ul className={styles.dropdownMenu}>
                    {options.map(option => (
                        <li
                            key={option.key}
                            className={styles.option}
                            onClick={() => handleSelect(option.key)}
                        >
                            {option.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default SelectDropDown;